<template>
  <div class="notification level is-marginless is-radiusless language-selector is-teal-blue">
    <div class="level-left">
      <div class="level-item">
        <div class="select is-white">
          <select
            class="has-text-white is-uppercase is-secondary"
            @change="$emit('input',$event.target.value)"
            :value="$store.getters.activeLanguage"
          >
            <option class="is-uppercase">ca</option>
            <option class="is-uppercase">es</option>
            <option class="is-uppercase">en</option>
          </select>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <slot name="right-buttons"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'language-bar',
  props: {
    value: { type: String, default: 'CA' }
  },
  created () {
    this.$emit('input', this.value)
  }
}
</script>

<style scoped>
.language-selector {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
}
</style>
